import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_DESCRIPTION_CONVERTER } from './index'
import { TrainingDescriptionConverter } from './training-description.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingDescriptionFeature: {
          module: () => import('./training-description.module').then((m) => m.TrainingDescriptionModule),
          cmsComponents: ['training_description'],
        },
      }
    }),
    {
      provide: TRAINING_DESCRIPTION_CONVERTER,
      useExisting: TrainingDescriptionConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_description: TRAINING_DESCRIPTION_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingDescriptionFeatureModule {
}
